<template>
  <div>
    <a-card v-if="listEnable" :bordered="false" style="position: relative;">
      <a-row :gutter="16" style="margin-bottom: 20px" :style="{ textAlign: 'right' }">
        <a-col :span="12" :offset="12">
          <a-button type="primary" v-if="store.getters.userType != 22">
            <a href="/型号导入模板.xlsx" style="text-decoration: none" download="型号导入模板.xlsx">下载导入模板</a>
          </a-button>
          <a-upload
            style="margin:0 8px"
            name="file"
            :action="uploadUrl"
            @change="handleChange"
            :headers="headers"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :showUploadList="false"
            :beforeUpload="beforeUpload"
          >
            <a-button v-if="addEnable && store.getters.userType != 22" type="primary" :disabled="fileList.length ==1">
              导入
            </a-button>
          </a-upload>
          <a-button v-if="deriveEnable" type="primary" @click="FileExcel">导出Excel</a-button>
        </a-col>
      </a-row>
      <div class="table-page-search-wrapper">
        <a-form layout="inline" >
          <a-row v-if="enterpriseId == ''" :gutter="16">
            <a-col :span="6">
              <a-form-item label="安装类别" style="margin-left: 28px">
                <a-select v-model="queryParam.installType" allowClear="true">
                  <a-select-option  v-for="type in restaurantTypes" :key="type.code">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业名称">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-model="queryParam.enterpriseId"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of data1" :title="item.enterpriseName" :key="item.enterpriseId">{{item.enterpriseName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="品牌名称">
                <a-input v-model="queryParam.brandName"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="型号">
                <a-input v-model="queryParam.modelName"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="安装难度得分" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="queryParam.installScore" allowClear="true">
                  <a-select-option v-for="(type,i) in numArr" :title="type" :key="i+1">{{type}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="版本号" style="margin-left: 14px">
                <a-input v-model="queryParam.modelVer"/>
              </a-form-item>
            </a-col>
            <a-col :span="6" :offset="6" :style="{ textAlign: 'right' }">
              <span>
                <a-button type="primary" htmlType="submit" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">清空</a-button>
              </span>
            </a-col>
          </a-row>
          <a-row v-if="enterpriseId != ''" :gutter="16">
            <a-col :span="6">
              <a-form-item label="安装类别">
                <a-select  v-model="queryParam.installType" allowClear="true">
                  <a-select-option  v-for="type in restaurantTypes" :key="type.code">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!--<a-col :span="6">-->
              <!--<a-form-item label="企业名称">-->
                <!--<a-select-->
                  <!--showSearch-->
                  <!--optionFilterProp="children"-->
                  <!--v-model="queryParam.enterpriseId"-->
                  <!--:filterOption="filterOption"-->
                  <!--allowClear="true"-->
                <!--&gt;-->
                  <!--<a-select-option v-for="item of data1" :title="item.enterpriseName" :key="item.enterpriseId">{{item.enterpriseName}}</a-select-option>-->
                <!--</a-select>-->
              <!--</a-form-item>-->
            <!--</a-col>-->
            <a-col :span="6">
              <a-form-item label="品牌名称">
                <a-input v-model="queryParam.brandName"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="型号">
                <a-input v-model="queryParam.modelName"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="安装难度得分" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="queryParam.installScore" allowClear="true">
                  <a-select-option v-for="(type,i) in numArr" :title="type" :key="i+1">{{type}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="版本号" style="margin-left: 14px">
                <a-input  v-model="queryParam.modelVer"/>
              </a-form-item>
            </a-col>
            <a-col :span="6" :offset="12" :style="{ textAlign: 'right' }">
              <span>
                <a-button type="primary" htmlType="submit" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">清空</a-button>
              </span>
            </a-col>
          </a-row>
          <a-divider> </a-divider>
          <a-row>
            <a-col :span="4":offset="20" style="text-align: end">
              <a-button v-if="addEnable" type="primary" icon="plus" @click="$refs.modal.add()">新增</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <s-table
        size="default"
        ref="table"
        style="margin-top: 20px"
        rowKey="modelId"
        :loading="loading"
        :columns="columns"
        :data="loadData"
        bordered
        :scroll="{ x: 200 }"
      >
      <span slot="installType" slot-scope="text, record">
         <td v-for="type in restaurantTypes" :key="type.code" v-if="record.installType == type.code">{{type.label}}</td>
      </span>
        <span slot="action" slot-scope="text, record">
          <a v-if="queryDetail" @click="handleShow(record)">查看</a>
          <a-divider v-if="queryDetail" type="vertical" />
          <a v-if="configureEnable" @click="handleDeploy(record)">配置</a>
          <a-divider v-if="editEnabel && configureEnable" type="vertical" />
          <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
          <a-divider v-if="removeEnable" type="vertical" />
          <a v-if="removeEnable" @click="delByIds(record.modelId)">删除</a>
          <span v-if="editEnabel">
            <a-divider type="vertical" />
            <a v-if="record.forbiddenStatus==1" @click="showState(record.modelId,record.forbiddenStatus)">启用</a>
            <a v-else @click="showState(record.modelId,record.forbiddenStatus)">禁用</a>
          </span>
        </span>
      </s-table>
      <model-modal ref="modal" @ok="handleOk"/>
      <a-modal
        title="导入文件详情"
        style="top: 20px;"
        v-model="visible"
        @ok="handleSubmit"
        :closable="false"
        :maskClosable="false"
      >
        <div style="margin-left: 50px">
          <p>
            <strong>导入成功数量 : </strong>
            <span>{{success}}</span>
          </p>
          <p>
            <strong>导入失败数量 : </strong>
            <sapn style="color: red">{{err}}</sapn>
          </p>
          <strong v-if="err == 0">全部导入成功！</strong>
          <strong v-else>是否下载导入失败文件？</strong>
        </div>
      </a-modal>
    </a-card>
    <no-authority v-if="!listEnable"></no-authority>
  </div>
</template>

<script>
import { STable } from '@/components'
import { getSlectCombox,downloadErrorModel,exportModel,getModelList, delModel,forbiddenModel,enableModel,getModelNumber } from '@/api/enterprise/model'
import ModelModal from './modules/ModelModal.vue'
import NoAuthority from './NoAuthority'
import { checkPermission } from '@/utils/permissions'
import {getDictMap} from "../../utils/dict"
import store from '@/store'
import {ACCESS_TOKEN} from '@/store/mutation-types'

export default {
  name: 'ModelList',
  components: {
    STable,
    ModelModal,
    NoAuthority
  },
  data () {
    return {
      store,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width:60,
          dataIndex: 'rowNum',
          align:'center'
        },{
          title: '操作',
          width:60,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          scopedSlots: { customRender: 'installType' },
          align:'center'
        },
        {
          title: '品牌名称',
          dataIndex: 'brandName',
          align:'center'
        },
        {
          title: '型号',
          dataIndex: 'modelName',
          align:'center'
        },
        {
          title: '安装难度得分',
          dataIndex: 'installScore',
          align:'center'
        },
        {
          title: '版本号',
          dataIndex: 'modelVer',
          align:'center'
        },
        {
          title: '规格（长度）(mm)',
          dataIndex: 'specLength',
          align:'center'
        },
        {
          title: '规格（宽度）(mm)',
          dataIndex: 'specWidth',
          align:'center'
        },
        {
          title: '添加人',
          dataIndex: 'createBy',
          align:'center'
        },
        {
          title: '添加时间',
          dataIndex: 'createTime',
          align:'center'
        }
      ],
      loadData: parameter => {
        return getModelList(Object.assign(parameter, this.queryParam))
      },
      fileList: [],
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      uploadUrl: process.env.VUE_APP_API_BASE_URL + '/enterprise/model/importModel',
      pagination: false,
      loading: false,
      visible: false,
      success: 0,
      err: 0,
      arrList:'',
      enterpriseId:'', //企业id
      data1:[],
      restaurantTypes:[],
      numArr:[],
      listEnable: checkPermission('enterprise:model:list'),
      addEnable: checkPermission('enterprise:model:add'),
      editEnabel: checkPermission('enterprise:model:edit'),
      removeEnable: checkPermission('enterprise:model:remove'),
      configureEnable:checkPermission('enterprise:modal:configure'),
      deriveEnable:checkPermission('enterprise:modal:derive'),
      queryDetail:checkPermission('enterprise:model:query:detail'),
    }
  },
  filters: {
  },
  async created () {
    this.enterpriseId = store.getters.enterpriseId
    this.restaurantTypes = [];
    this.restaurantOperTypeMap = await getDictMap('install_type');
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes.push({code: key, label: value})
    })
    for (var i=1;i<11;i++){
      // console.log(i)
      this.numArr.push(i)
    }
    getSlectCombox().then(res=>{
      // console.log(res.data)
      this.data1 = res.data
    })
  },
  methods: {
    // 导出
    FileExcel(){
      var str=process.env.VUE_APP_API_BASE_URL + '/enterprise/model/exportModel?pageNum=1&pageSize=10'
      for(let i in this.queryParam ){
        if(this.queryParam[i]!=undefined){
          str=str+'&'+i+'='+this.queryParam[i]
        }
      }
      str=str+'&token='+this.headers.token
      window.open(str)
      // exportModel(this.queryParam).then(res=>{
      //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
      //   const a = document.createElement('a')
      //   // 生成文件路径
      //   let href = window.URL.createObjectURL(blob)
      //   a.href = href
      //   let fileName = '型号管理'
      //   // 文件名中有中文 则对文件名进行转码
      //   a.download = decodeURIComponent(fileName)
      //   // 利用a标签做下载
      //   document.body.appendChild(a)
      //   a.click()
      //   document.body.removeChild(a)
      //   window.URL.revokeObjectURL(href)
      // })
    },
    handleAdd () {
      this.$refs.modal.add()
    },
    handleEdit (record) {
      this.$refs.modal.edit(record)
    },
    handleShow(record){
      this.$refs.modal.edit(record,1)
    },
    handleDeploy(record){
      this.$refs.modal.deploy(record)
    },
    handleOk (value) {
      // console.log(value)
      if(value == 1){
        this.$refs.table.refresh(true)
      }else{
        this.$refs.table.refresh()
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    showState (modelId, forbiddenStatus) {
      if (forbiddenStatus == 0) {
        forbiddenModel({ 'modelId': modelId }).then(res => {
          // console.log(res)
          if (res.code === 0) {
            this.$message.success('禁用成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (forbiddenStatus == 1) {
        enableModel({ 'modelId': modelId }).then(res => {
          // console.log(res)
          if (res.code === 0) {
            this.$message.success('启动成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    beforeUpload(file){
      // console.log(file)
    },
    // 确定导出失败文件

    handleSubmit(){
      if(this.err == 0){
        this.visible = false
      }else{
        downloadErrorModel(this.arrList).then(res=>{
          const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
          const a = document.createElement('a')
          // 生成文件路径
          let href = window.URL.createObjectURL(blob)
          a.href = href
          let fileName = '导入失败型号文件'
          // 文件名中有中文 则对文件名进行转码
          a.download = decodeURIComponent(fileName)
          // 利用a标签做下载
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(href)
        })
        this.visible = false
      }
    },
    handleChange(info) {
       console.log(info,'res')
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        this.$message.success('上传成功')
        console.log(info.file.response.data)
        let file = info.file.response.data
        this.visible = true
        this.success =file.success
        this.err =file.error
        this.arrList =file.errorList
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`);
      }
    },
    delByIds (modelId) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          delModel({'modelId': modelId}).then(res => {
            if (res.code === 0) {
              that.$message.success('删除成功')
              that.handleOk()
            } else {
              that.$message.error(res.msg)
            }
          })
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
  .ant-divider.ant-divider-horizontal {
    margin:12px 0 !important;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px !important;}
</style>
